import { trackVideoEngagement } from '../videoUtils';

declare global {
    interface Window {
        YT: typeof YT;
        onYouTubeIframeAPIReady?: () => void;
    }
}

export function loadYouTubeAPI(onReady: () => void) {
    if (window.YT && window.YT.Player) {
        onReady();
        return;
    }

    const existingScript = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
    if (existingScript) {
        window.onYouTubeIframeAPIReady = onReady;
        return;
    }

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = onReady;
}

export function extractYouTubeVideoId(url: string): string | null {
    // Handle formats https://youtu.be/YTYo_0MsV7O, https://www.youtube.com/watch?v=YTYo_0MsV7O, https://youtube.com/shorts/YTYo_0MsV7O
    try {
        const parsed = new URL(url);
        if (parsed.hostname.includes('youtube.com') && parsed.pathname === '/watch') {
            return parsed.searchParams.get('v');
        }
        if (parsed.hostname.includes('youtube.com') && parsed.pathname.startsWith('/shorts/')) {
            return parsed.pathname.slice('/shorts/'.length) || null;
        }
        if (parsed.hostname === 'youtu.be') {
            return parsed.pathname.slice(1) || null;
        }
    } catch (e) {
        console.warn('Failed to parse YouTube URL:', e);
    }
    return null;
}

export function createPlaybackRateChangeHandler(videoUrl: string) {
    return (event: { target: YT.Player; data: number }) => {
        const rate = event.data;
        trackVideoEngagement('playback_rate', videoUrl, [], [rate]);
    };
}
